// Быстрый ввод позиции одной строкой: «молоко 2 л», «яйца 10», «картошка 1.5кг».

const UNIT_ALIASES: Record<string, string> = {
  кг: "kg", kg: "kg", кило: "kg",
  г: "g", гр: "g", g: "g",
  л: "l", l: "l", литр: "l", литра: "l", литров: "l",
  шт: "pcs", штук: "pcs", штуки: "pcs", dona: "pcs", ta: "pcs",
  уп: "pack", упак: "pack", пачка: "pack", пачки: "pack", qadoq: "pack",
};

export interface QuickItem {
  name: string;
  qty: number | null;
  unit: string | null;
}

export function parseQuickItem(input: string): QuickItem {
  const text = input.trim().replace(/\s+/g, " ");
  const m = text.match(/^(.*?)\s+(\d+(?:[.,]\d+)?)\s*([a-zа-яё']+)?\.?$/i);
  if (m && m[1]) {
    const unitRaw = m[3]?.toLowerCase();
    const unit = unitRaw ? UNIT_ALIASES[unitRaw] : undefined;
    if (!unitRaw || unit) {
      const qty = Number(m[2]!.replace(",", "."));
      if (qty > 0) return { name: m[1], qty, unit: unit ?? null };
    }
  }
  return { name: text, qty: null, unit: null };
}

/** Сравнение названий позиций: «Молоко» и «молоко », «ё» и «е» — одно и то же. */
export function sameNameKey(name: string): string {
  return name.toLowerCase().replace(/ё/g, "е").replace(/\s+/g, " ").trim();
}
